// @flow
import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";

export const Container = styled.div`
  background-color: ${buildColor("navy", "default")};
  padding: 16px 16px;
`;

export const Title = styled.h1`
  color: ${buildColor("white", "100")};
  font-family: ${fontBold};
  font-weight: 500;
  font-size: 18px;
  line-height: 125%;
`;

export const Label = styled.p`
  color: ${buildColor("white", "100")};
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: normal;
  line-height: 125%;
`;
